import { render, staticRenderFns } from "./ClassroomRow.vue?vue&type=template&id=7ac81587&"
import script from "./ClassroomRow.vue?vue&type=script&lang=js&"
export * from "./ClassroomRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports